import { jsx as c, jsxs as z } from "react/jsx-runtime";
import { forwardRef as E } from "react";
const N = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  EXPRESSIVE: "expressive"
}, O = {
  LG: "lg"
};
function T(u) {
  return u && u.__esModule && Object.prototype.hasOwnProperty.call(u, "default") ? u.default : u;
}
var m = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var w;
function R() {
  return w || (w = 1, function(u) {
    (function() {
      var o = {}.hasOwnProperty;
      function n() {
        for (var t = "", r = 0; r < arguments.length; r++) {
          var e = arguments[r];
          e && (t = s(t, p(e)));
        }
        return t;
      }
      function p(t) {
        if (typeof t == "string" || typeof t == "number")
          return t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return n.apply(null, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var r = "";
        for (var e in t)
          o.call(t, e) && t[e] && (r = s(r, e));
        return r;
      }
      function s(t, r) {
        return r ? t ? t + " " + r : t + r : t;
      }
      u.exports ? (n.default = n, u.exports = n) : window.classNames = n;
    })();
  }(m)), m.exports;
}
var A = R();
const g = /* @__PURE__ */ T(A), B = "_rotate_1xozj_1", P = "_dash_1xozj_1", _ = {
  "purpur-spinner": "_purpur-spinner_1xozj_1",
  rotate: B,
  "purpur-spinner--xxs": "_purpur-spinner--xxs_1xozj_4",
  "purpur-spinner--xs": "_purpur-spinner--xs_1xozj_8",
  "purpur-spinner--sm": "_purpur-spinner--sm_1xozj_12",
  "purpur-spinner--md": "_purpur-spinner--md_1xozj_16",
  "purpur-spinner--lg": "_purpur-spinner--lg_1xozj_20",
  "purpur-spinner__circle": "_purpur-spinner__circle_1xozj_24",
  dash: P,
  "purpur-spinner__circle--disabled": "_purpur-spinner__circle--disabled_1xozj_33",
  "purpur-spinner__circle--negative": "_purpur-spinner__circle--negative_1xozj_36"
}, a = "purpur-spinner", C = {
  SM: "sm"
}, I = ({
  ["data-testid"]: u,
  disabled: o = !1,
  negative: n = !1,
  size: p = C.SM,
  ...s
}) => /* @__PURE__ */ c(
  "div",
  {
    className: g([_[a], _[`${a}--${p}`]]),
    "data-testid": u,
    ...s,
    children: /* @__PURE__ */ c("svg", { viewBox: "0 0 50 50", children: /* @__PURE__ */ c(
      "circle",
      {
        className: g(_[`${a}__circle`], {
          [_[`${a}__circle--disabled`]]: o,
          [_[`${a}__circle--negative`]]: n
        }),
        cx: "25",
        cy: "25",
        r: "20"
      }
    ) })
  }
);
function M(u) {
  return u && u.__esModule && Object.prototype.hasOwnProperty.call(u, "default") ? u.default : u;
}
var d = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var h;
function V() {
  return h || (h = 1, function(u) {
    (function() {
      var o = {}.hasOwnProperty;
      function n() {
        for (var t = "", r = 0; r < arguments.length; r++) {
          var e = arguments[r];
          e && (t = s(t, p.call(this, e)));
        }
        return t;
      }
      function p(t) {
        if (typeof t == "string" || typeof t == "number")
          return this && this[t] || t;
        if (typeof t != "object")
          return "";
        if (Array.isArray(t))
          return n.apply(this, t);
        if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
          return t.toString();
        var r = "";
        for (var e in t)
          o.call(t, e) && t[e] && (r = s(r, this && this[e] || e));
        return r;
      }
      function s(t, r) {
        return r ? t ? t + " " + r : t + r : t;
      }
      u.exports ? (n.default = n, u.exports = n) : window.classNames = n;
    })();
  }(d)), d.exports;
}
var D = V();
const U = /* @__PURE__ */ M(D), Y = {
  "purpur-button": "_purpur-button_w455q_1",
  "purpur-button--xs": "_purpur-button--xs_w455q_33",
  "purpur-button--icon-only": "_purpur-button--icon-only_w455q_36",
  "purpur-button--sm": "_purpur-button--sm_w455q_39",
  "purpur-button--md": "_purpur-button--md_w455q_45",
  "purpur-button--lg": "_purpur-button--lg_w455q_51",
  "purpur-button--full-width": "_purpur-button--full-width_w455q_57",
  "purpur-button--primary": "_purpur-button--primary_w455q_60",
  "purpur-button--disabled": "_purpur-button--disabled_w455q_64",
  "purpur-button--primary-negative": "_purpur-button--primary-negative_w455q_70",
  "purpur-button--secondary": "_purpur-button--secondary_w455q_82",
  "purpur-button--secondary-negative": "_purpur-button--secondary-negative_w455q_93",
  "purpur-button--expressive": "_purpur-button--expressive_w455q_104",
  "purpur-button--expressive-negative": "_purpur-button--expressive-negative_w455q_114",
  "purpur-button--negative": "_purpur-button--negative_w455q_126",
  "purpur-button--destructive": "_purpur-button--destructive_w455q_133",
  "purpur-button--destructive-negative": "_purpur-button--destructive-negative_w455q_143",
  "purpur-button--tertiary-purple": "_purpur-button--tertiary-purple_w455q_153",
  "purpur-button--tertiary-purple-negative": "_purpur-button--tertiary-purple-negative_w455q_166",
  "purpur-button--text-negative": "_purpur-button--text-negative_w455q_181",
  "purpur-button--text": "_purpur-button--text_w455q_181"
}, L = {
  ...N,
  DESTRUCTIVE: "destructive",
  TERTIARY_PURPLE: "tertiary-purple",
  TEXT: "text"
}, K = Object.values(L), G = U.bind(Y), i = "purpur-button", Q = ["button", "submit", "reset"], X = ({
  children: u,
  className: o,
  ["data-testid"]: n,
  disabled: p = !1,
  fullWidth: s = !1,
  iconOnly: t,
  loading: r = !1,
  negative: e = !1,
  onClick: b,
  size: f = "md",
  variant: l,
  type: q = "button",
  ...v
}, j) => {
  if (t && l === "destructive")
    return null;
  const S = G(
    [
      i,
      `${i}--${e ? `${l}-negative` : l}`,
      `${i}--${f}`
    ],
    {
      [`${i}--icon-only`]: t,
      [`${i}--negative`]: e,
      [`${i}--full-width`]: s,
      [`${i}--disabled`]: p || r
    },
    o
  ), $ = (y) => {
    p || r ? y.preventDefault() : b && b(y);
  }, x = !!v["aria-disabled"] || p || r;
  return /* @__PURE__ */ z(
    "button",
    {
      className: S,
      "data-testid": n,
      type: q,
      ref: j,
      "aria-disabled": x,
      onClick: $,
      ...v,
      children: [
        r && /* @__PURE__ */ c(I, { size: f === O.LG ? "xs" : "xxs", negative: e, disabled: x }),
        " ",
        u
      ]
    }
  );
}, F = E(X);
F.displayName = "Button";
export {
  Q as BUTTON_TYPES,
  L as BUTTON_VARIANT,
  F as Button,
  K as buttonVariants
};
//# sourceMappingURL=button.es.js.map
